var x_listeners = function () { };

x_listeners.prototype = {
    init: function () {
        var me = this;
        $(function () {

            me.elements();
            me.forms();
            me.modals();
            me.tooltips();

            if (!$('.xnavigation').hasClass('rendered')) {
                me.nav();
            }
            xcontrols.init();

            $('div.xgrid:not(.xgrid_initialized)').each(function (i, el) {
                new xgrid().init($(el));
            });

            $('.xgrid2:not(.xgrid_initialized)').each(function (i, el) {
                new xtable().init($(el));
                if ($(this).find('.xfilter_button').length > 0) {
                    new xfilter().init($($(this).find('.xfilter_button')));
                }
            });

            $(window).off('popstate').on('popstate', function (e) {
                // handlina histoy back
                e.preventDefault();

                var url = location.pathname + (location.search ? location.search : ''); // gal geriau imti location.href
                xhelper.content.load(url, {
                    history: false
                });
            });
        });

        return me;
    },
    ajax: function (target) {
        var me = this;

        xcontrols.init();
        me.forms(); // reikia init formas, kai pakraunama per xhelper.contrent.load()
        me.modals();
        me.tooltips();

        $('div.xgrid:not(.xgrid_initialized)').each(function (i, el) {
            new xgrid().init($(el));
        });

        return me;
    },
    modals: function () {
        var me = this;

        // $('a[data-modal]').off('click');
        $('a[data-modal]:not(.modal-event)').click(function (e) {
            e.preventDefault();
            if(document.body.classList.contains('modal-open') && e.currentTarget.classList.contains('modal-event')){
                return;
            }
            loadingbar.start();
            var a = $(this),
                modal = a.data('modal'),
                module = a.data('module'),
                title = a.data('title'),
                fk = a.data('fk'),
                pk = a.data('pk'),
                post = a.data('post'),
                form = a.closest('form'),
                width = a.data('width') || 'lg',
                backdrop = a.data('backdrop'),
                style = a.data('style');

                a.addClass('modal-event');
            // a.off('click');
            if (a.data('dataset')) {
                if (post === undefined) {
                    post = {};
                }
                //post.checked = $('.xgrid[data-dataset='+a.data('dataset')+']')[0].xgrid.getCheckedValues();
            }



            

            if (a.closest('.xgrid2').length > 0) {
                post = {};
                post.checked = a.closest('.xgrid2').xtable().getCheckedValues();
            }


            xdialog.modal.show({
                title,
                //modal: modal,
                module,
                pk,
                fk,
                post,
                width,
                style,
                backdrop
            }, modal);
        });
        //neaiski vieta
        $(document).on('shown.bs.modal', function () {
            xcontrols.init();
            me.tooltips();
            var modal = $('.modal-dialog');
            modal.draggable({
                handle: '.modal-header'
            });
            modal.on('dragstop', function (e, ui) {
                var positionTop = parseInt(e.currentTarget.style.top);
                (positionTop < 0) ? e.currentTarget.style.top = 0 : null;
            });

            loadingbar.stop();
        });
    },
    tooltips: function () {
        $('[data-tooltip]:not(.tooltipstered)').each(function (i, el) {
            xdialog.tooltip.show($(el));
        });
    },
    elements: function () {
        var not = 'a:not([href^="mailto\\:"], [href^="javascript\\:\\;"], [href^="localexplorer\\:"], [href*=\\#], [target$="_blank"], [role="tab"], [download], [data-reload])';

        $(document).off('click', not).on('click', not, function (event) {
            if (params.url === 'web' || web.lineage.includes('/components/') || web.lineage.includes('/pm/')) return true; // web nevykdomas content load

            if ($(this).hasClass('xsearch')) {
                loadingbar.search();
                return;
            }

            /*
			if (params.url !== 'cweb') {
				loadingbar.start();
				return true;
			}
            */

            event.preventDefault();
            xhelper.content.load(event.currentTarget.href);
        });

        $('.xpaginator .perpage select.simple').on('change', function (e) {
            var url = xhelper.url.setParam('paging', $(this).val());
            //nes gali nelikti to page, kuris buvo parinktas

            window.location = url.replace(/(page=[^&]*)/g, 'page=1');
        });

        $(document).on('click', 'button.xsearch', function (event) {
            loadingbar.search();
        });

        $(document).on('click', 'a.xreset', function (event) {
            let reset_btn = $(this),
                not = reset_btn.data('reset-hidden') == 1 ? '' : '';
            reset_btn.closest('form').find('select, input' + not).val('').trigger('change');
        });


        // nav active toggle
        $(document).off('click', '.xsidebar .nav-tabs a').on('click', '.xsidebar .nav-tabs a', function () {
            var clicked = $(this),
                singlemodule = clicked.data('singlemodule');

            $('.xsidebar-content')[singlemodule ? 'removeClass' : 'addClass']('open');
            $('.ham-menu')[singlemodule ? 'addClass' : 'removeClass']('disabled');

            clicked.closest('.nav-tabs').find('a').removeClass('active');
            clicked.addClass('active');
        });


        $('.xsidebar .xcatalog li a').on('click', function () {
            var clicked = $(this);
            clicked.closest('.tab-content').find('a').removeClass('active');
            clicked.addClass('active');
        });

        $('.xnav-modules li').on('click', function (e) {
            $('.xnav-modules li a').removeClass('active');
            $(this).find('a').addClass('active');
        });

        $(document).on('click', '.ham-menu:not(.disabled)', function () {
            $('.xsidebar-content').toggleClass('open')
        });
    },
    nav: function () {
        $('.xnavigation').addClass('rendered');
        // xnav-modules groups
        $('.xnav-groups li a').on('click', function (e) {
            let pid = $(this).attr('aria-controls'),
                secTab = $('.xnav-secondary').find('#' + pid);

            if (!secTab.length) {
                $('.xnav-secondary .tab-pane').removeClass('show active');
                $('.xnav-modules li a').removeClass('active');
            }
        });

        // Sidebar stuff
        toggleScrollbars();
        $('.xnavigation-group-link').click(function (e) {
            // e.preventDefault();
            $(e.currentTarget).toggleClass('active');
        });

        $('.xnavigation-toggle').click(function (e) {
            $('.xnavigation').toggleClass('open', !$('.xnavigation').hasClass('open'));

            let status = $('.xnavigation').hasClass('open') ? 1 : 0

            xcrud.load(
                '/xstorage/menu/' + status,
                null,
                response => {
                    return;
                });
            toggleScrollbars();
        });



        function toggleScrollbars() {
            if ($('.xnavigation-list').length === 0) {
                return;
            }
            var navScroll = $('.xnavigation-list').overlayScrollbars({}).overlayScrollbars();

            if (!$('.xnavigation').hasClass('open')) {
                navScroll.destroy();
            } else {
                navScroll = $('.xnavigation-list').overlayScrollbars({}).overlayScrollbars();
            }
        }

        //ACTIVE TOGGLE
        let moduleLinks = $('.xnavigation-link, .xnavigation-group-empty');
        moduleLinks.click(function (e) {
            //e.stopPropagation();
            moduleLinks.removeClass('active');
            $(e.currentTarget).addClass('active');
        });


        // Search :(
        var groupsLength = $('.xnavigation-group').length,
            activeGroup = $('.xnavigation-group .active').first();
        $('.xnavigation-search input').on('keyup keydown focus blur', function (e) {
            var value = xhelper.string.aliasify($(this).val()),
                group = $('.xnavigation-group');
            // Toglinam clear buttona
            $('.xnavigation-search .input-clear-btn').toggleClass('d-none', value.length == 0);

            if (value.length == 0) {
                group.toggleClass('d-none', false);
                $('.xnavigation-link').toggleClass('d-none', false);
                // Checkinam ar yra grupes
            } else if (group.find('.xnavigation-group-name:contains(' + value + ')').length > 0) {
                $('.xnavigation-group:not(:contains(' + value + '))').toggleClass('d-none', true);
                group.find('.xnavigation-group-name:contains(' + value + ')').closest('.xnavigation-group').find('.xnavigation-link').removeClass('d-none');
                // Chekinam tarp moduliu
            } else if ($('.xnavigation-link:contains(' + value + ')').length > 0) {
                group.toggleClass('d-none', true);
                $('.xnavigation-link:not(:contains(' + value + '))').toggleClass('d-none', true);
                $('.xnavigation-link:contains(' + value + ')').closest('.xnavigation-group').removeClass('d-none');
                $('.xnavigation-link:contains(' + value + ')').removeClass('d-none');
            } else {
                group.toggleClass('d-none', true);
                $('.xnavigation-link').toggleClass('d-none', true);
            }

            // Metam active klase jeigu viena grupe paieskoi
            if (group.not('.d-none').length == 1) {
                group.find('.xnavigation-group-link').addClass('active');
            } else {
                group.find('.xnavigation-group-link').removeClass('active');
                activeGroup.addClass('active');
            }
        });

        $('.xnavigation-search .input-clear-btn').click(e => {
            e.preventDefault();
            moduleLinks.removeClass('d-none');
            $('.xnavigation-group').removeClass('d-none');
            $(e.currentTarget).addClass('d-none').siblings(':input').val('');
        });
    },
    forms: function () {
        //debugger;
        $('form:not(.xform)').each(function (e) {

            var form = $(this),
                initialState = false,
                buttons = form.find('button[type=submit]');


            if (form.attr('autocomplete') !== 'on') {
                form.attr('autocomplete', 'off');
            }

            form[0].initialState = initialState;

            form.on('keyup change paste', 'input, select, textarea, file', function () {
                form[0].initialState = true;
            });

            form.validate({
                onkeyup: false
            });

            buttons.each(function () {
                var btn = $(this);

                btn.click(function () {
                    // safari netaiko focus ant button click, reikia forcinti del submit
                    $(this).focus();
                });
            });

            form.submit(function (ev) {
                ev.preventDefault();
                if (form.valid() === false) {
                    loadingbar.stop();
                    return false;
                }

                var btn = form.find('button[type=submit]:focus');

                if (btn.length === 0) {
                    btn = form.find('button[type=submit]');
                }

                if (btn.hasClass('xsearch')) {
                    ev.currentTarget.submit();
                    return true;
                }

                var config = {
                        form: form,
                        url: btn.data('url'),
                        async: btn.data('async'),
                        disablenotify: false
                    },
                    callback = btn.data('callback'),
                    data = form.serialize(),
                    submitUrl = btn.data('submit-url') || $(this).attr('action') /*this.action*/;



                if (btn.data('trigger') && !submitUrl) {
                    submitUrl = '/php/json/save.php' + btn.data('trigger');
                }

                if (ev.isTrigger == 3) {
                    callback = null;
                    config.url = null;
                    config.disablenotify = true;
                }


                if (btn.data('question')) {
                    xdialog.question.show({
                        title: btn.data('questionTitle'),
                        text: btn.data('questionQuestion')
                    }, function (confirm) {
                        if (!confirm) return;
                        let fn = btn.data('before-submit');
                        if (typeof window[fn] === 'function') {
                            return window[fn](function (submit) {
                                if (submit) {
                                    xcrud.json.save(submitUrl, data, callback, config);
                                }
                            });
                        } else {
                            xcrud.json.save(submitUrl, data, callback, config);
                        }
                    });
                } else if (btn.data('before-submit') && typeof window[btn.data('before-submit')] === 'function') {
                    return window[btn.data('before-submit')](function (submit) {
                        if (submit) {
                            data = form.serialize();
                            xcrud.json.save(submitUrl, data, callback, config);
                        }
                    });
                } else {
                    xcrud.json.save(submitUrl, data, callback, config);
                }

            });

            form.addClass('xform');
        });
    },
    resolution: function (reload) {
        xcrud.json.send('/php/actions/resolution.php', {
            availHeight: screen.availHeight,
            availWidth: screen.availWidth,
            height: screen.height,
            width: screen.width,
            colorDepth: screen.colorDepth,
            pixelDepth: screen.pixelDepth
        }, function () {
            if (reload === true) {
                window.location.reload();
            }
        });
    },
    hash: function () {
        document.addEventListener('DOMContentLoaded', function (event) {
            var hash = window.decodeURI(location.hash.replace('#', ''))
            if (hash !== '') {
                var element = document.getElementById(hash)
                if (element) {
                    var offset = element.offsetTop
                    // Wait for the browser to finish rendering before scrolling.
                    setTimeout((function () {
                        window.scrollTo(0, offset - 0)
                    }), 0);
                }
            }
        });
    }
};



var xlisteners = new x_listeners().init();